module.exports = __webpack_public_path__ + "static/img/bg03.433dcc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personagens/bg/bg03.jpg
// module id = 723
// module chunks = 2 3 4 5 27